import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import "./webhooksTable.css";
import { getAllMerchnatWebhooks } from "../../../config/LiveApi";
import { FaEdit } from "react-icons/fa";
import EditWebhookModal from "./Modal";

const WebhooksTable = () => {
  const token = useSelector((store) => store.userReducer.token);
  const [isLoading, setIsLoading] = useState(false);
  const [merchantWebhooks, setMerchantWebhooks] = useState([]);
  const [selectedWebhook, setSelectedWebhook] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    fetchWebhooks();
  }, [token]);

  const fetchWebhooks = async () => {
    setIsLoading(true);
    try {
      const response = await getAllMerchnatWebhooks(token);
      if (response?.data) {
        const adminsOnly = response.data.filter(
          (webhook) => webhook.role === "admin"
        );
        setMerchantWebhooks(adminsOnly);
      }
    } catch (error) {
      toast.error("Failed to fetch merchant webhooks.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditClick = (webhook) => {
    setSelectedWebhook(webhook);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedWebhook(null);
  };

  return (
    <div className="webhooks-report-table-container">
      <h2 className="webhooks-report-table-title">Merchant Webhooks</h2>
      <table className="webhooks-table">
        <thead>
          <tr>
            <th>Merchant Name</th>
            <th>Payin URL</th>
            <th>Payout URL</th>
            <th>Created At</th>
            <th>Updated At</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan="6">Loading...</td>
            </tr>
          ) : merchantWebhooks.length > 0 ? (
            merchantWebhooks.map((webhook) => (
              <tr key={webhook.webhookId}>
                <td>{webhook.merchantName}</td>
                <td>{webhook.payinURL}</td>
                <td>{webhook.payoutURL}</td>
                <td>
          {webhook.createdAt
            ? `${new Date(webhook.createdAt).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })} ${new Date(webhook.createdAt).toLocaleTimeString("en-GB", {
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: true,
              })}`
            : "N/A"}
        </td>
        <td>
          {webhook.updatedAt
            ? `${new Date(webhook.updatedAt).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })} ${new Date(webhook.updatedAt).toLocaleTimeString("en-GB", {
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: true,
              })}`
            : "N/A"}
        </td>
                <td>
                  <FaEdit onClick={() => handleEditClick(webhook)} />
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4">No admin merchants webhooks found.</td>
            </tr>
          )}
        </tbody>
      </table>

      {showModal && selectedWebhook && (
        <EditWebhookModal
          webhook={selectedWebhook}
          token={token}
          onClose={closeModal}
          onUpdate={fetchWebhooks}
        />
      )}
    </div>
  );
};

export default WebhooksTable;
